module.exports = __webpack_public_path__ + "img/15_47.2553f851.png";